import { render, staticRenderFns } from "./FormTwoFA.vue?vue&type=template&id=8753186e&scoped=true"
import script from "./FormTwoFA.vue?vue&type=script&lang=js"
export * from "./FormTwoFA.vue?vue&type=script&lang=js"
import style0 from "./FormTwoFA.vue?vue&type=style&index=0&id=8753186e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8753186e",
  null
  
)

export default component.exports